var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-polygon',{attrs:{"lat-lngs":_vm.poi.coordinates,"color":"#2E59D8","visible":_vm.visible}},[_c('l-tooltip',[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.poi.name))]),_c('p',[_vm._v(_vm._s(_vm.poi.description))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }